import React, { useContext } from "react";
import { ProjectContext, TranslationContext, NotificationsContext, Icon } from "@swegon/sds-core";
import styled from "styled-components";

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const CopyButton = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    &:hover {
        opacity: 0.8;
    }
`;

const CopyProjectId = () => {
    const { project } = useContext(ProjectContext);
    const { l } = useContext(TranslationContext);
    const notificationsContext = useContext(NotificationsContext);

    if (!project) return null;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(project.ProjectId);
            notificationsContext.addNotification(l("projectDetails.projectIdAddedToClipboard"));
        } catch (error) {
            notificationsContext.addNotification(l("projectDetails.couldNotCopyProjectId"), {
                level: "error"
            });
        }
    };

    return (
        <Container>
            <CopyButton onClick={handleCopy}>
                <Icon icon='copy' size={16} tooltip={l("projectDetails.copyProjectId")} />
            </CopyButton>
        </Container>
    );
};

export default CopyProjectId;
